{
  "collapse": "Restrângeți",
  "expand": "Extindeți"
}
